module.exports = __webpack_public_path__ + "static/media/death-card.ee1e0da7.svg";